import { useRecordContext } from 'react-admin';

import { Badge } from '../components/ui/badge';
import { useZoneStatus } from '../pricing/useZoneStatus';

/**
 * Whether this case's pickup falls inside Zone 1 — read only.
 *
 * The same answer the contract shows, from the same hook, so the case and the
 * contract can never disagree. No calculate button on purpose: pricing belongs
 * on the contract, where there is a line to write and a number a family will be
 * held to.
 */
/**
 * `funeral` must be passed wherever this renders inside a <ReferenceField> —
 * the sidebar's Deceased card among them — because there the record context is
 * the CLIENT, not the case. Reading the context blindly returns a client, which
 * has no place of death, and the component reports "no address" for a case that
 * plainly has one. PlaceOfDeathValue takes the same prop for the same reason.
 */
export const FuneralTransportZone = ({ funeral }: { funeral?: any } = {}) => {
  const contextRecord = useRecordContext<any>();
  const record = funeral ?? contextRecord;
  const status = useZoneStatus(record ?? {});

  if (!record) return null;

  // The sidebar's Row is `flex justify-between`, so the value container fills
  // the space left over and its contents start at ITS left edge — flush against
  // the label. Every value in that column has to right-align itself.
  if (status.state === 'no_address') {
    return (
      <span className="block text-right text-muted-foreground">
        No address — zone can't be checked
      </span>
    );
  }

  if (status.state === 'not_located') {
    return (
      <span className="block text-right text-muted-foreground">
        Not checked — no coordinates stored
      </span>
    );
  }

  return (
    <span className="cleo-ui flex flex-wrap items-center justify-end gap-1.5 text-right">
      {status.state === 'in_zone' ? (
        <>
          <Badge variant="success" className="whitespace-nowrap">Inside Zone 1</Badge>
          <span className="text-muted-foreground">{status.municipality} — included</span>
        </>
      ) : (
        <>
          <Badge variant="warning" className="whitespace-nowrap">Outside Zone 1</Badge>
          <span className="text-muted-foreground">charged per km on the contract</span>
        </>
      )}
      {status.pickup.overridden && (
        <Badge variant="outline" className="whitespace-nowrap">pickup overridden</Badge>
      )}
    </span>
  );
};

export default FuneralTransportZone;
